import React from 'react';
import { Modal, Table, Form, Empty, Input, Button } from 'antd';
import auth from '../common/utility/auth';
import global from '../common/utility/global';
import { LOGISTICA_PRODUCTOS_CON_LOTE, VENTA_PRECIO_UNITARIO_INCLUYE_IGV } from '../common/types/parametroType'
import { VENTAS, LOGISTICA } from '../common/types/sistemaType'
import './style.css';

const { Search } = Input;

class SearchProductModal extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
        }
    }

    handleSearch = (value) => {
        const dataSource = this.props.dataSource.filter(item => {
            return (item.codigoReferencia + ' - ' + item.nombre)
                .toUpperCase()
                .match(value.toUpperCase());
        });
        this.props.form.setFieldsValue({ dataSource });
    };

    render() {
        const precioUnitarioInclIGV = auth.user().parametros.filter(m => m.abreviatura === VENTA_PRECIO_UNITARIO_INCLUYE_IGV)[0].valor === "1" ? true : false;
        const mostrarLoteProducto = auth.user().parametros.filter(m => m.abreviatura === LOGISTICA_PRODUCTOS_CON_LOTE)[0].valor === "1" ? true : false;
        if (this.props.dataSourceAgregado !== undefined && this.props.dataSourceAgregado.length !== 0) {
            this.props.dataSource.forEach(element => {
                var exist = this.props.dataSourceAgregado.filter(m => m.idProducto === element.id && m.numeroLote === element.numeroLote);
                if (exist.length !== 0)
                    element['flagAgregado'] = true;
            });
        }
        const { getFieldDecorator, getFieldValue } = this.props.form;
        getFieldDecorator('dataSource', { initialValue: this.props.dataSource });
        getFieldDecorator('loading', { initialValue: false });
        return (
            <Modal
                className='table-search-product-component'
                title={"Búsqueda de Producto ó Servicio"}
                visible={this.props.visible}
                style={{ top: 30 }}
                width="1000px"
                onCancel={() => {
                    this.props.form.resetFields();
                    this.props.onCancel()
                }}
                footer={[
                    <Button
                        key="send"
                        type="primary"
                        onClick={() => {
                            this.props.form.resetFields();
                            this.props.onCancel()
                        }}
                    >
                        Ok
                    </Button>
                ]}
            >
                <Form>
                    <div className="row">
                        <div className="col-md-12 form-group">
                            <Form.Item label="">
                                {getFieldDecorator('codigoNombre', {
                                    initialValue: ''
                                })(
                                    <Search
                                        placeholder="Búsqueda por Código o Nombre"
                                        autoComplete="off"
                                        maxLength={100}
                                        loading={this.props.loadingProduct}
                                        onChange={(e) => this.handleSearch(e.target.value)}
                                        enterButton={"Buscar"}

                                        onSearch={value => this.props.onBuscarProducto(value, this.props.form)}
                                    />
                                )}
                            </Form.Item>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-12">
                            <Table
                                rowClassName={(record, index) => !record.flagAgregado ? 'cursor-pointer' : 'cursor-pointer agregados'}
                                className="table-search-product-component"
                                size="small"
                                style={{ overflowX: 'auto' }}
                                rowKey={record => `${record.id}-${record.numeroLote}`}
                                dataSource={getFieldValue('dataSource')}
                                onRow={(item) => ({ onClick: () => (this.props.onSelect(item)) })}
                                locale={{
                                    emptyText: <Empty
                                        image={Empty.PRESENTED_IMAGE_SIMPLE}
                                        description="No se encontraron datos."
                                    />
                                }}
                                columns={[
                                    {
                                        title: 'Código',
                                        dataIndex: 'codigoReferencia',
                                        key: 'codigoReferencia'
                                    },
                                    {
                                        title: 'Nombre',
                                        dataIndex: 'nombre',
                                        key: 'nombre'
                                    },
                                    {
                                        title: 'Tipo de Producto',
                                        dataIndex: 'nombreTipoProducto',
                                        key: 'nombreTipoProducto'
                                    },
                                    {
                                        title: 'Unidad de Medida',
                                        dataIndex: 'nombreUnidadMedida',
                                        key: 'nombreUnidadMedida'
                                    },
                                    {
                                        title: 'Marca',
                                        dataIndex: 'nombreMarca',
                                        key: 'nombreMarca'
                                    },
                                    {
                                        title: 'Lote',
                                        dataIndex: 'numeroLote',
                                        key: 'numeroLote',
                                        className: mostrarLoteProducto ? 'show' : 'hide'
                                    },
                                    {
                                        title: 'Fecha Vcto.',
                                        dataIndex: 'fechaVencimientoStr',
                                        key: 'fechaVencimientoStr',
                                        className: mostrarLoteProducto ? 'show' : 'hide'
                                    },
                                    (
                                        this.props.validarStock ?

                                            {
                                                title: 'Stock Disponible',
                                                dataIndex: 'stockDisponible',
                                                key: 'stockDisponible',
                                                align: 'right',
                                                className: this.props.validarStock ? 'show' : 'hide',
                                                render: (data) => (
                                                    <span>{data.toFixed(2)}</span>
                                                )
                                                /*        title: 'Stock',
                                                       children: [
                                                           {
                                                               title: 'Stock Disponible',
                                                               dataIndex: 'stockDisponible',
                                                               key: 'stockDisponible',
                                                               align: 'right',
                                                               className: this.props.validarStock ? 'show' : 'hide',
                                                               render: (data) => (
                                                                   <span>{data.toFixed(2)}</span>
                                                               )
                                                           },
                                                           {
                                                               title: 'Stock Comprometido',
                                                               dataIndex: 'stockComprometido',
                                                               key: 'stockComprometido',
                                                               align: 'right',
                                                               className: this.props.validarStock ? 'show' : 'hide',
                                                               render: (data) => (
                                                                   <span>{data.toFixed(2)}</span>
                                                               )
                                                           },
                                                           {
                                                               title: 'Stock Total',
                                                               dataIndex: 'stock',
                                                               key: 'stock',
                                                               align: 'right',
                                                               className: this.props.validarStock ? 'show' : 'hide',
                                                               render: (data) => (
                                                                   <span>{data.toFixed(2)}</span>
                                                               )
                                                           }
                                                       ] */
                                            }
                                            :
                                            {}
                                    ),
                                    (
                                        /*                this.props.precioUnitInclyIGV === true ?  
                                                       {
                                                           title: 'Precio Unitario',
                                                           dataIndex: 'precioUnitario',
                                                           key: 'precioUnitario',
                                                           align: 'right',
                                                           render: (data) => (
                                                               <span>{data.toFixed(2)}</span>
                                                           )
                                                       }
                                                       :
                                                       {
                                                           title: 'Valor Unitario',
                                                           dataIndex: 'precioUnitario',
                                                           key: 'precioUnitario',
                                                           align: 'right',
                                                           render: (data) => (
                                                               <span>{data.toFixed(2)}</span>
                                                           )
                                                       } */


                                        this.props.idSistema === LOGISTICA ?
                                            {
                                                title: 'Precio Promedio',
                                                dataIndex: 'precioPromedio',
                                                key: 'precioPromedio',
                                                align: 'right',
                                                render: (data) => (
                                                    <span>{data.toFixed(2)}</span>
                                                )
                                            }
                                            :
                                            {
                                                title: (precioUnitarioInclIGV ? 'Precio Unitario' : 'Valor Unitario'),
                                                dataIndex: 'precioUnitario',
                                                key: 'precioUnitario',
                                                align: 'right',
                                                render: (data) => (
                                                    <span>{data.toFixed(2)}</span>
                                                )
                                            }
                                    )




                                ]}
                            />
                        </div>
                    </div>
                </Form>
            </Modal>
        );
    }
}
export default Form.create()(SearchProductModal)